import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';

@Component({
  selector: 'page-not-found',
  templateUrl: 'notFound.html'
})
export class NotFoundPage {

  modalCtrl : ModalController;
  events : Events;

	constructor(public navCtrl: NavController, public navParams: NavParams,modalCtrl : ModalController, events : Events) {
		this.modalCtrl = modalCtrl;
    this.events = events;
	}
  
}



// WEBPACK FOOTER //
// ./src/util/notFound/notFound.ts